import React from 'react'

import '../lp.css'
import './LandingPage.css';

import { Stats } from '../About';
const LandingPage = () => {
    return (
        <div className='SectionLP'>
            <div className='BCIlp'/>
        <div className='LandingPageVPESSection '>
            <div className='StatsPlusContainer  ' >
                 
            <div className='LandingPageVPESContainer'>
                <div className='ContentLandingPage'>
                    
                    <span className='v'>
                        <h1 style={{color:"#DC0000"}}>Vishwas <span className='power'>Power</span> </h1>
                    
                    </span>
                    
                    <h1>
                    Engineering Services
                    </h1>
                   
                   <div className='subtitleLanding'>
                   <p className='sndSub'> 
                    Total solutions on Power Transformers and 
                    </p>
                    <p className='sndSub'>Railway Electrification</p>
                   </div>
                </div>
                <div className='LogoLandingPage'>
                    <img src="/Vishvas_Power.svg" alt="logo"/>
                   
                </div>
            </div>
            <div className='StatsContianer' >
            <Stats/>
        </div>  
        </div>
        
        </div>

        </div>
    )
}

export default LandingPage